import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68721d02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "price" }
const _hoisted_3 = {
  key: 0,
  class: "price-month"
}
const _hoisted_4 = {
  key: 0,
  class: "price-promo"
}
const _hoisted_5 = {
  key: 1,
  class: "price-month"
}
const _hoisted_6 = { class: "price-currency-name" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "price-month" }
const _hoisted_9 = { class: "price-currency-name" }
const _hoisted_10 = {
  key: 0,
  class: "coupon-monthly-payment"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  class: "monthly-payment"
}
const _hoisted_14 = {
  key: 2,
  class: "monthly-payment"
}
const _hoisted_15 = { style: {"text-align":"center"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "button-block" }
const _hoisted_18 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanPriceWithCoupon = _resolveComponent("PlanPriceWithCoupon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["wrapper", [_ctx.variant, _ctx.special ? 'special' : '']])
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.planCard.name), 1),
      (_ctx.selectedSubscription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.promo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    (_ctx.couponType === 'amount' && _ctx.couponDuration > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _createVNode(_component_PlanPriceWithCoupon, {
                            "base-price": _ctx.basePrice,
                            "price-month": _ctx.priceMonth,
                            image: _ctx.planCard.name,
                            "is-new-price": "oldPrice"
                          }, null, 8, ["base-price", "price-month", "image"]),
                          _createVNode(_component_PlanPriceWithCoupon, {
                            "base-price": _ctx.price,
                            "price-month": _ctx.priceMonthCoupon,
                            "is-new-price": "newPrice",
                            color: _ctx.variant
                          }, null, 8, ["base-price", "price-month", "color"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createTextVNode(_toDisplayString(_ctx.priceMonth ? _ctx.priceMonth.split('€')[0] :_ctx.selectedSubscription.priceMonth) + " ", 1),
                          _createElementVNode("span", _hoisted_6, "€" + _toDisplayString(_ctx.priceMonth.split('€')[1]), 1)
                        ]))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, [
                      _createTextVNode(_toDisplayString(_ctx.price ? _ctx.price : _ctx.selectedSubscription.price) + " ", 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.planCard.name !== "Pro" ? "€/mes" : "€*"), 1)
                    ])
                  ]))
            ]),
            (_ctx.subscriptionValues.length > 1 &&
             (_ctx.couponDuration > 0))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_ctx.couponDuration === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Durante " + _toDisplayString(_ctx.couponDuration === 0 ? 1 : _ctx.couponDuration) + " mes ", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, " Durante " + _toDisplayString(_ctx.couponDuration) + " meses ", 1)),
                  _createElementVNode("span", null, " Después " + _toDisplayString(_ctx.basePrice ? _ctx.basePrice : _ctx.selectedSubscription) + "€ ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.subscriptionValues.length > 1 && _ctx.promo && _ctx.couponDuration === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.price ? _ctx.price : _ctx.selectedSubscription.price) + "€ Pago único", 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSubscription?.elementsFront, (element) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "elements",
            key: element
          }, [
            _createElementVNode("span", null, _toDisplayString(element.$paymentTitle), 1),
            _hoisted_16,
            _createElementVNode("span", null, _toDisplayString(element.$elementText), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createTextVNode(_toDisplayString(_ctx.$route.query.page) + " ", 1),
      (_ctx.url !== 'change-plan')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            variant: _ctx.variant,
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('selected', { planCard: _ctx.planCard, id: _ctx.selectedSubscription?.id });
          })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Seleccionar ")
            ]),
            _: 1
          }, 8, ["variant"]))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            variant: _ctx.variant,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selected', { planCard: _ctx.planCard, id: _ctx.selectedSubscription?.id })
          ))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Seleccionar ")
            ]),
            _: 1
          }, 8, ["variant"])),
      (_ctx.selectedSubscription.name === 'PRO')
        ? (_openBlock(), _createElementBlock("p", _hoisted_18, " *Este servicio no cuenta con packs de 3 o 6 meses. "))
        : _createCommentVNode("", true)
    ])
  ], 2))
}